import apiFetch, { APIFetchOptions } from '@wordpress/api-fetch'

export const apiFetchWithTimeout = async <T>(
    options: Omit<APIFetchOptions, 'signal'>,
    timeout?: number,
): Promise<T> => {
    const controller = typeof AbortController === 'undefined' ? undefined : new AbortController()

    const id = setTimeout(() => controller?.abort(), timeout)

    const response = await apiFetch<T>({
        ...options,
        signal: controller?.signal,
    })
    clearTimeout(id)
    return response
}

export const fetchWithTimeout = async <T>(
    input: Parameters<typeof fetch>[0],
    options: Parameters<typeof fetch>[1] & { timeout?: number } = {},
): Promise<T> => {
    const controller = typeof AbortController === 'undefined' ? undefined : new AbortController()

    const id = setTimeout(() => controller?.abort(), options?.timeout || 5 * 60 * 1000)

    const response = await fetch(input, {
        ...options,
        signal: controller?.signal,
    })
    clearTimeout(id)

    const data = (await response.json()) as T

    return data
}
